import React from "react";
import {
  PAGE_SHELL,
  PAGE_HEADER_ROW,
  PAGE_SUBTITLE,
} from "../../ui/pageChrome";
import { BILLING_THEME, billingThemeCssVars } from "./billingTheme";
import { ReceiptIcon } from "../../Icons";

/**
 * Patient Billing module is temporarily disabled for all roles.
 * Sidebar entry stays visible with a Coming Soon affordance.
 */
const BillingModule = () => (
  <div className={PAGE_SHELL} style={billingThemeCssVars}>
    <div className={PAGE_HEADER_ROW}>
      <div>
        <h1 className={`text-2xl font-bold ${BILLING_THEME.section.title}`}>
          Billing
        </h1>
        <p className={PAGE_SUBTITLE}>
          Patient claims, ledger, and payer billing
        </p>
      </div>
    </div>

    <div className="flex flex-col items-center justify-center rounded-xl border border-slate-200 bg-white px-6 py-20 text-center shadow-sm">
      <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
        <ReceiptIcon size={28} />
      </span>
      <p className="mt-4 text-lg font-semibold text-slate-800">Coming Soon</p>
      <p className="mt-1.5 max-w-sm text-sm text-slate-500">
        The Billing module is temporarily unavailable. Check back later.
      </p>
    </div>
  </div>
);

export default BillingModule;
